/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SocialNetworkIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Social Network',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m17.95544,8.12915c.02747-.22266-.0592-.44727-.24548-.58276l-7.34277-5.3335c-.02917-.02124-.0625-.03223-.09412-.04785-.02063-.01062-.03931-.02271-.06116-.03101-.05188-.0188-.10522-.02759-.15942-.0321-.02148-.00232-.04028-.01257-.06226-.01257h-.00098c-.04663,0-.08789.01697-.13159.02686-.01868.00439-.0376.00513-.05591.01123-.05713.01843-.10693.04602-.15552.0791-.00415.00293-.00928.00378-.01343.00684l-.04541.03296c-.01318.01147-.02979.01807-.04199.03052L2.29102,7.54883c-.02417.01746-.04041.04126-.06128.0614-.0199.01904-.04016.03577-.05737.0575-.04614.05786-.08398.12109-.10693.19031-.00049.00134-.00146.00208-.00195.0033-.00049.00171,0,.0033-.00049.00488-.02197.0697-.02832.14294-.02502.21704.00122.02588.0072.04956.0116.07495.00513.02979.00439.05981.01392.08936l2.80566,8.63086c.00977.03003.02832.05457.04224.08228.01099.02197.01953.04382.0332.0647.04175.06348.09082.12073.15137.16479l.00073.00073c.00879.00635.01904.00842.02808.01428.04565.02966.09326.05676.14563.07385.06287.02051.12781.03101.1925.03101.00012,0,.00024-.00012.00037-.00012s.00037.00012.00061.00012l9.0752-.00098c.02905,0,.05566-.00952.08386-.01343.02783-.00378.05457-.00549.08191-.01318.14587-.04041.27026-.13135.35352-.25818.01379-.02112.02246-.04333.03357-.06567.01379-.02747.0321-.05188.04187-.08167l2.80371-8.63184c.00977-.03027.00916-.06104.01416-.0918.00098-.0083.00317-.01587.00378-.02417Zm-3.63171,7.19519l-3.30957-4.55432,5.34717-1.71863-2.0376,6.27295ZM3.63135,9.02734l5.3584,1.74023-3.31067,4.55762-2.04773-6.29785Zm6.9856-5.08801l5.38782,3.91321-5.37976,1.72949-.00806-5.6427Zm-1.24219,5.63928l-5.35706-1.73999,5.34924-3.88745.00781,5.62744Zm.62622,1.92383l3.31128,4.55676-6.62183.00073,3.31055-4.5575Z"
      fill="currentColor"
      opacity=".6"
      stroke-width="0"
    />
    <circle cx="9.9972" cy="2.60374" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="5.41642" cy="16.74518" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="10" cy="10.34887" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="14.55749" cy="16.71049" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="17.40009" cy="8.08823" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="2.59991" cy="8.08069" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="9.9972" cy="2.60374" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="5.41642" cy="16.74518" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="10" cy="10.34887" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="14.55749" cy="16.71049" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="17.40009" cy="8.08823" r="1.49968" fill="currentColor" stroke-width="0" />
    <circle cx="2.59991" cy="8.08069" r="1.49968" fill="currentColor" stroke-width="0" />
  </svg>`;
};
